import _ from 'lodash'

export function normalizeToDay(date) {
  if (!_.isString(date)) {
    date = date.toJSON()
  }
  return date.substring(0, 10)
}
